import * as actions from './shared-auth-call.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { loadingSharedAuthCall } from 'src/app/shared/_config/i18n/i18n-interface';
import { mergeMap } from 'rxjs/operators';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';

@Injectable()
export class SharedAuthCallEffects {
    private readonly actions$ = inject(Actions);


    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                action: loadingSharedAuthCall
            }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingSharedAuthCall
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingSharedAuthCall
            }),
        ]))
    );
}
